<template>
  <span
    :aria-hidden="decorative"
    :aria-label="title"
    class="cancel-pipe"
    role="img"
  >
    <svg
      :fill="fillColor"
      class="material-design-icon__svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M22,14H20V16H14V13H16V11H14V6C14,4.9 13.1,4 12,4H4V2H2V10H4V8H10V11H8V13H10V18C10,19.1 10.9,20 12,20H20V22H22"
      />
      <path
        d="M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20C16.42,20 20,16.42 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z"
      />
      <title>{{ title }}</title>
    </svg>
  </span>
</template>

<script>
export default {
  name: "PipeCancelIcon",
  props: {
    title: {
      type: String,
      default: "Pipe cancel icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>
<style scoped>
.cancel-pipe {
  height: 24px;
}
</style>
